import type { NormalizedLocale } from "@shared/utils/locale/types";

/**
 * Basic normalization of the locale to the IETF BCP 47 format we accept, i.e:
 * - ISO 639-1 code for the language
 * - Optionally followed by a hyphen, containing a
 * - ISO 3166-1 alpha-2 code for the region
 */
export const normalizeLocale = (locale: string): NormalizedLocale => {
  const [language, region] = locale.replace("_", "-").split("-");

  const normalizedLanguage = language.toLowerCase();

  if (!region) {
    return { language: normalizedLanguage };
  }

  const normalizedRegion = region.toUpperCase();

  return {
    locale: `${normalizedLanguage}-${normalizedRegion}`,
    language: normalizedLanguage,
    region: normalizedRegion,
  };
};
